import { Spot } from "Domain/Model/Spot/Spot";

export const CREATE_SPOT_SUCCESS = 'CREATE_SPOT_SUCCESS';

export const createSpotSuccess = (payload: Record<string, Spot> ) => ({
    type: CREATE_SPOT_SUCCESS,
    payload,
});